/* eslint-disable import/no-unresolved */
import SVG from 'react-inlinesvg';

import { Icons } from '@/types/icons';
import icons from '@/utils/icon';

interface IconProps {
  icon: Icons;
  width?: number;
  height?: number;
}

const Icon: React.FC<IconProps> = ({ icon, width, height }) => (
  <SVG src={icons[icon]} width={width} height={height} />
);

export default Icon;
